const THEME_CLASSES = [
    "light",
    "amoled",
    "noir",
    "solarized",
    "archive",
    "signal-blue",
    "abyss",
    "infrared",
    "aurora",
    "deep-field",
    "zima-blue",
    "sea",
    "space",
] as const;

const THEME_MAP: Record<string, string | null> = {
    Dark: null,
    Light: "light",
    AMOLED: "amoled",
    Noir: "noir",
    Archive: "archive",
    Solarized: "solarized",
    "Signal Blue": "signal-blue",
    Abyss: "abyss",
    Infrared: "infrared",
    Aurora: "aurora",
    "Deep Field": "deep-field",
    "Zima Blue": "signal-blue",
    Sea: "abyss",
    Space: "deep-field",
};

const FONT_CLASSES = ["bs-font-small", "bs-font-medium", "bs-font-large"] as const;

export function applyThemeClass(theme: string): void {
    const html = document.documentElement;

    // Remove all theme classes first
    THEME_CLASSES.forEach((cls) => html.classList.remove(cls));

    if (theme === "Auto") {
        const prefersLight = window.matchMedia("(prefers-color-scheme: light)").matches;
        if (prefersLight) {
            html.classList.add("light");
        }
        return;
    }

    const cls = THEME_MAP[theme];
    if (cls) {
        html.classList.add(cls);
    }
}

export function applyDisplayPreferences(
    fontSize = "Medium",
    glow = true,
    reduceMotion = false,
    highContrast = false
): void {
    const html = document.documentElement;
    FONT_CLASSES.forEach((cls) => html.classList.remove(cls));

    const fontClass =
        fontSize === "Small" ? "bs-font-small" :
        fontSize === "Large" ? "bs-font-large" :
        "bs-font-medium";

    html.classList.add(fontClass);
    html.classList.toggle("bs-glow-off", glow === false);
    html.classList.toggle("bs-reduce-motion", reduceMotion === true);
    html.classList.toggle("bs-high-contrast", highContrast === true);
}

export function applyStoredAppearance(): void {
    applyThemeClass(localStorage.getItem("theme") || "Light");
    applyDisplayPreferences(
        localStorage.getItem("fontSize") || "Medium",
        localStorage.getItem("glow") !== "false",
        localStorage.getItem("reduceMotion") === "true",
        localStorage.getItem("highContrast") === "true"
    );
}
